import { Injectable, inject } from '@angular/core';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';
import { LanguageService } from '../../application/services/language.service';
import { takeRecentFailure } from './correlation';
import { arabicToast } from './toast-messages';

/**
 * OPS-02: every screen shows its own error toast (about 160 of them, each worded its own way). Instead of
 * touching each one, the error toast that follows a failed server call gets the call's reference appended,
 * so the user can quote it and support finds the request in the logs.
 */
@Injectable()
export class ErpToastrService extends ToastrService {
  private readonly language = inject(LanguageService);

  /** DS-04: a fixed English toast in Arabic when the screen is in Arabic (see toast-messages). */
  private local(message?: string): string | undefined {
    return this.language.getCurrent() === 'ar' ? arabicToast(message) : message;
  }

  override success<ConfigPayload = any>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<any> {
    return super.success(this.local(message), this.local(title), override);
  }

  override warning<ConfigPayload = any>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<any> {
    return super.warning(this.local(message), this.local(title), override);
  }

  override info<ConfigPayload = any>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<any> {
    return super.info(this.local(message), this.local(title), override);
  }

  override error<ConfigPayload = any>(message?: string, title?: string, override?: Partial<IndividualConfig<ConfigPayload>>): ActiveToast<any> {
    message = this.local(message);
    title = this.local(title);
    const ref = takeRecentFailure();
    if (ref && !(message ?? '').includes(ref)) {
      const label = this.language.getCurrent() === 'ar' ? 'المرجع' : 'Ref';
      message = `${message ?? ''} (${label}: ${ref})`.trim();
    }
    return super.error(message, title, override);
  }
}
